import data from './data'
import state from './state'
import * as actions from './actions'
import * as mutations from './mutations'

export default {
  data,
  state,
  actions,
  mutations
}
